import {createReducer} from '@reduxjs/toolkit';
import {clearEventsFilters, setAllEventsFilters, setEventsFilter} from 'src/modules/events/services/filters/actions';
import {Filters} from 'src/modules/events/typedefs';

type State = {
    data: Filters,
};

export const defaultState: State = {
    data: {
        source: [],
        type: [],
        families: [],
        code: [],
        description: [],
        attributes: [],
        firstUsageDate: {from: '', to: ''},
        lastUsageDate: {from: '', to: ''},
    },
};

export const eventsFilters = createReducer<State>(defaultState, builder => builder
    .addCase(setEventsFilter, (state, action) => {
        state.data = {
            ...state.data,
            [action.payload.filterType]: action.payload.filterValue,
        };
    })
    .addCase(clearEventsFilters, state => {
        state.data = defaultState.data;
    })
    .addCase(setAllEventsFilters, (state, action) => {
        state.data = action.payload;
    }),
);
